'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var KEYWORD_SELECTED = exports.KEYWORD_SELECTED = 'SEARCH_TERMS:KEYWORD_SELECTED';
var LOCATION_SELECTED = exports.LOCATION_SELECTED = 'SEARCH_TERMS:LOCATION_SELECTED';
var INSURER_SELECTED = exports.INSURER_SELECTED = 'SEARCH_TERMS:INSURER_SELECTED';
var SEARCH_TEXT_CHANGED = exports.SEARCH_TEXT_CHANGED = 'SEARCH_TERMS:SEARCH_TEXT_CHANGED';

var SearchTermsActions = {
	keywordSelected: function keywordSelected(selectedKeyword) {
		return {
			type: KEYWORD_SELECTED,
			selectedKeyword: selectedKeyword
		};
	},
	locationSelected: function locationSelected(selectedLocation) {
		return {
			type: LOCATION_SELECTED,
			selectedLocation: selectedLocation
		};
	},
	insurerSelected: function insurerSelected(selectedInsurer) {
		return {
			type: INSURER_SELECTED,
			selectedInsurer: selectedInsurer
		};
	},
	searchTextChanged: function searchTextChanged(text) {
		return {
			type: SEARCH_TEXT_CHANGED,
			text: text
		};
	}
};

exports.default = SearchTermsActions;